import { render, staticRenderFns } from "./SingleMail.vue?vue&type=template&id=5b26a135"
import script from "./SingleMail.vue?vue&type=script&lang=js"
export * from "./SingleMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports